import type { ApiRoute, NoBody, NoQueryParams } from "../../api"
import type { VisibilityEditView } from "./VisibilityEditView"

export interface GetVisibilityEditViewPathParams {
	inventoryId: string
}

export const getVisibilityEditViewRoute: ApiRoute<
	GetVisibilityEditViewPathParams,
	NoQueryParams,
	NoBody,
	VisibilityEditView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/visibility-edit`,
	method: "get",
	path: "/vehicles/:inventoryId/visibility-edit",
}
